import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-primary-dark text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-heading font-bold mb-4">VON</h3>
            <p className="text-gray-300 font-body text-sm mb-4">
              Advanced Servo Voltage Stabilizers for Residential, Commercial and Industrial Applications.
            </p>
            <p className="text-gray-400 text-xs font-body">
              Designed & Manufactured in India
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2 font-body text-sm">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors" data-testid="footer-link-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors" data-testid="footer-link-about">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-300 hover:text-white transition-colors" data-testid="footer-link-products">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors" data-testid="footer-link-contact">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3 font-body text-sm">
              <li className="flex items-center gap-2 text-gray-300">
                <Phone size={16} />
                <a href="tel:+917305955155" className="hover:text-white transition-colors" data-testid="footer-phone">
                  +91 73059 55155
                </a>
              </li>
              <li className="flex items-center gap-2 text-gray-300">
                <Mail size={16} />
                <a href="mailto:sale@voninda.in" className="hover:text-white transition-colors" data-testid="footer-email">
                  sale@voninda.in
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700 mt-8 pt-6 text-center">
          <p className="text-gray-400 text-sm font-body">
            © {new Date().getFullYear()} VON. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
